import { Typography } from '@rossum/ui/material';

type SidebarSectionTitleProps = {
  title: string;
  dataCy?: string;
  dataSectionLabel?: string;
  ghost?: boolean;
};

export const SidebarSectionTitle = ({
  title,
  dataCy,
  dataSectionLabel,
  ghost,
}: SidebarSectionTitleProps) => {
  const color = ghost ? 'text.disabled' : undefined;

  return (
    <Typography
      variant="h6"
      color={color}
      data-cy={dataCy}
      data-section-label={dataSectionLabel}
      sx={{
        py: 1,
        px: 2,
      }}
    >
      {title}
    </Typography>
  );
};
